export default "/_next/static/assets/images/sprite.ef5ef6ff0dd6f5f96d097fa0d4234673.svg";